<app-base-list-wrapper [baseListComponent]="this" />
